import BaseView, { DomainModel3D } from './base-view';
import SectionView from './section-view';
import VerticalPanelView from './vertical-panel-view';
import logging from '../logging';
import { ClosetUnit } from '../domain';
import { ClosetUnitViewConfig, ClosetUnitViewOptions } from './views-config';
import { Mesh } from 'three';
import { update } from "../json/optional-properties";

const log = logging('view');

export default class ClosetUnitView extends BaseView {

    declare model: ClosetUnit;

    config: ClosetUnitViewConfig;

    private leftPanel: VerticalPanelView;
    private rightPanel: VerticalPanelView;

    private content: SectionView;

    highlights: Set<Mesh> = new Set();

    constructor(model: DomainModel3D, options: ClosetUnitViewOptions) {
        super(model);
        update(this.config, options);
        this.onReady.name = 'ClosetUnitView';
        this.init();
    }

    make() {

        this.userData.isParametric = true;
        this.name = 'ClosetUnit';

        if(this.model.leftPanel) {
            this.leftPanel = new VerticalPanelView(this.model.leftPanel, this.config),
            this.add(this.leftPanel);
        }
        if(this.model.rightPanel) {
            this.rightPanel = new VerticalPanelView(this.model.rightPanel, this.config),
            this.add(this.rightPanel);
        }
        this.content = new SectionView(this.model.content);
        this.add(this.content);
        this.onReady.trigger();
    }

    bind(): void {
        // nothing to do
    }
}
